import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { SimpleFormControl } from "../../../components/form/SimpleFormControl";
import { SimpleFormSelect } from "../../../components/form/SimpleFormSelect";
import { UserRole } from "../../../transports/user";
import { useUserListByRole } from "src/app/hooks";
import { useField } from "formik";
import { PlatformType } from "src/app/types/Platform";
import { useAuth } from "src/app/utils/useAuth";
import { CheckRoles } from "src/app/utils/CheckRoles";

export const UpsertPlatformAgencyFormBody: React.FC = () => {
    const { isLead } = CheckRoles;
    const { formatMessage } = useIntl();
    const [, , helper] = useField("type");
    const { currentUser } = useAuth();
    const { userListByRole: managers, loading } = useUserListByRole(
        [UserRole.ROLE_LEAD_BUSINESS_MANAGER, UserRole.ROLE_BUSINESS_MANAGER],
        isLead(currentUser.role) ? "" : "onlyCurrentUser"
    );

    useEffect(() => {
        helper.setValue(PlatformType.AGENCY);
    }, []);

    return (
        <Container>
            <Row>
                <Col>
                    <SimpleFormControl
                        label={formatMessage({ id: "common.field.name" })}
                        name="name"
                    />
                </Col>
                <Col>
                    <SimpleFormControl
                        label={formatMessage({ id: "common.field.email" })}
                        name="login"
                    />
                </Col>
                <SimpleFormSelect
                    label={formatMessage({ id: "common.field.business_manager" })}
                    isLoading={loading}
                    name="managerId"
                    values={managers?.map((v) => ({
                        label: `${v.firstName} ${v.lastName}`,
                        value: v.id,
                    }))}
                />
                <SimpleFormControl
                    label={formatMessage({ id: "common.field.comment" })}
                    name="comment"
                    as="textarea"
                    rows={5}
                />
            </Row>
        </Container>
    );
};
